// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/build/css/" + chunkId + "." + "3897b1ed3cb971fbe9f7" + ".css";
};